// Sometime happens in mobile browsers
// (reproduced in Safari in responsive mode on macOS)
// when app follow user to external page (e.g. during MFA switching or social login)
// and user press browser back button on that page
// the page is not reloaded and app freeze in previous state
// How to use:
// pass callback to useBrowserBackButtonEvent that will be called on browser back button event detected
// before redirecting user to external page call setBrowserBackButtonListener
// after user return to app call removeBrowserBackButtonListener to remove listener
import { nextTick } from 'vue';

export function useBrowserBackButtonEvent(listener: () => void) {
  function onBrowserBackButtonEvent() {
    nextTick(listener);
  }

  function onBrowserPageShow() {
    const perfEntries = performance.getEntriesByType('navigation');
    if (perfEntries?.length) {
      const { type } = (perfEntries[0] as PerformanceNavigationTiming);
      if (['back_forward', 'reload', 'navigation'].includes(type)) onBrowserBackButtonEvent();
    } else if (performance?.navigation?.type === 2) {
      onBrowserBackButtonEvent();
    }
  }

  function setBrowserBackButtonListener() {
    window.addEventListener('pageshow', onBrowserPageShow);
  }

  function removeBrowserBackButtonListener() {
    window.removeEventListener('pageshow', onBrowserPageShow);
  }

  return {
    setBrowserBackButtonListener,
    removeBrowserBackButtonListener,
  };
}
